import {IStateService} from 'angular-ui-router';
import VersicherungsbeitragModelManager from '../../../core/service/VersicherungsbeitragModelManager';
import ZahlungsauftragRS from '../../../core/service/ZahlungsauftragRS.rest';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {TSBeitragStatus} from '../../../models/enums/TSBeitragStatus';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import {isStatusInBearbeitung, TSVersicherungsbeitragStatus} from '../../../models/enums/TSVersicherungsbeitragStatus';
import TSBeitrag from '../../../models/TSBeitrag';
import TSVersicherungsbeitrag from '../../../models/TSVersicherungsbeitrag';
import TSZahlungsauftragDTO from '../../../models/TSZahlungsauftragDTO';
import DVBernUtil from '../../../utils/DVBernUtil';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./versicherungsbeitragBeitragView.scss');
let template = require('./versicherungsbeitragBeitragView.html');

export class BeitragViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BeitragViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        versicherungsbeitrag: '<',
    };
}

export class BeitragViewController extends AbstractGesuchViewController<TSVersicherungsbeitrag> {

    versicherungsbeitrag: TSVersicherungsbeitrag;
    form: IFormController;
    schadenfallId: string;
    readonly: boolean;
    schadenfallStatus: TSSchadenfallStatus;
    zahlungsauftrag: TSZahlungsauftragDTO;

    static $inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log', '$state', 'VersicherungsbeitragModelManager',
        'ZahlungsauftragRS'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private  $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private versicherungsbeitragModelManager: VersicherungsbeitragModelManager,
                private zahlungsauftragRS: ZahlungsauftragRS) {
        super($scope);
    }

    $onInit() {
        super.$onInit();
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag();
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        } else {
            this.initialModel = this.versicherungsbeitrag;
            this.model = angular.copy(this.versicherungsbeitrag);
        }
        this.readonly = !isStatusInBearbeitung(this.model.status);

        if (this.model.status === TSVersicherungsbeitragStatus.AUSZAHLUNG && this.model.beitrag === undefined) {
            this.model.beitrag = new TSBeitrag();
        }

        if (this.model.beitrag && this.model.beitrag.beitragStatus === TSBeitragStatus.AUSGEFUEHRT) {
            this.zahlungsauftragRS.getZahlungsauftraegeForBeitrag(this.model.beitrag.id).then((response: TSZahlungsauftragDTO) => {
                this.zahlungsauftrag = response;
            });
        }
    }

    public cancelVersicherungsbeitrag() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();

    }

    public getViewTitle(): string {
        return this.dvBernUtil.getVersicherungsbeitragViewTitle(this.model);
    }



    public saveVersicherungsbeitrag() {
        if (this.isModelValid() && this.model) {
            this.versicherungsbeitragModelManager.saveVersicherungsbeitrag(this.model).then((result: any) => {
                this.initialModel = result;
                this.model = angular.copy(this.initialModel);
            });
        } else {
            this.$log.debug('Form was not valid when saving versicherungsbeitrag');
        }
    }

    public saveVersicherungsBeitragBeitrag() {
        if (this.isModelValid() && this.model && this.model.beitrag) {
            this.versicherungsbeitragModelManager.saveVersicherungsbeitragBeitrag(this.model.beitrag).then((result: TSBeitrag) => {
                this.$state.go('versicherungsbeitraege')
            });
        } else {
            this.$log.debug('Form was not valid when saving versicherungsbeitragbeitrag');
        }
    }

    public cancelVersicherungsbeitragbeitrag() {
        this.model.beitrag = undefined;
    }

    public addAllowed(): boolean {
        //ist der ermittelte schaden gespeichert? nur dann koennen wir einen Beitrag erfassen
        let isErmittelterSchadenSet = this.initialModel.ermittelterSchaden !== undefined && this.initialModel.ermittelterSchaden !== null;
        return isErmittelterSchadenSet && !this.getModel().beitrag;
    }

    public addBeitrag() {
        if (this.isModelValid() && this.model) {
            this.model.beitrag = new TSBeitrag();
        }
    }

    public deleteBeitrag() {
        if (this.model.beitrag && !this.model.beitrag.isNew()) {
            //gespeicherten Beitrag loeschen
            this.versicherungsbeitragModelManager.deleteBeitrag().then((result: any) => {
                this.initialModel = result;
                this.model = angular.copy(this.initialModel);
                this.readonly = false;
            });
            return;
        } else {
            //    ungespeicherten Beitrag zuruecksetzen (entweder aus initial model wenn vorhanden oder sonst neues leeres
            if (this.initialModel.beitrag) {
                this.model.beitrag = angular.copy(this.initialModel.beitrag);
            }
        }
        this.model = this.versicherungsbeitragModelManager.clearBeitrag();
        this.readonly = false;
    }

    public isBeitragReadonly(): boolean {
        return !!this.model.beitrag && this.model.beitrag.beitragStatus !== TSBeitragStatus.NICHT_FREIGEGEBEN
    }

}



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/component/versicherungsbeitragBeitragView/versicherungsbeitragBeitragView.ts